import { Alignment, Button, Dialog, FormGroup, HTMLSelect, InputGroup, Tab, Tabs } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa, newIResultadosFilters } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { LookupStore } from "../../stores/LookupStore";
import { NotasStore } from "../../stores/notas/NotasStore";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { toast } from "react-toastify";
import { formatCnpj, isValidEmail } from "../../utils";
import { ContestarDialog } from "../contestar/ContestarDialog";
import { ContestarLoteDialog } from "../contestar/ContestarLoteDialog";
import { ContestarProduto } from "../contestar/ContestarProdutoDialog";
import {
  EmpresaSelect,
  filterEmpresa,
  renderEmpresa,
} from "../empresa/EmpresaSelect";
import NotasManual from "../notas/manual";
import { DateRangePicker } from "../utils/DateRangePicker";
import { ResultadosSummary } from "./resumo/ResultadosSummary";
import { ContestarLoteProdutosDialog } from "../contestar/ContestarLoteProdutoDialog";
import moment from "moment";
import DetalhamentoCte from "./detalhamento/detalhamento_cte";
import DetalhamentoNfse from "./detalhamento/detalhamento_nfse";
import DetalhamentoNfe from "./detalhamento/detalhamento_nfe";
import { ContestarSugeridoDialog } from "../contestar/ContestarSugeridoDialog";
import LoadingModal from "../loading/LoadingModal";
import { DateRangePicker30 } from "../utils/DateRangePicker30";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { v4 as uuidv4 } from 'uuid';
import { RelatorioStore } from "../../stores/relatorio/RelatorioStore";
import { AppIcon } from "../utils/AppIcon";
import InfoModal from "../info-modal/InfoModal";


var debounce = require('lodash.debounce');

interface IProps {
  changeTab: (tabId: string) => void;
}

@observer
export default class ResultadosCalculos extends React.Component<IProps, {}> {

  obs = observable({
    selectedPeriod: [] as any,
    fetchOptions: {} as any,
    open_rastreamentos: false as boolean,
    open_info: false as boolean,
    info_row: null as any
  })

  constructor(props) {
    super(props);

    ResultadoStore.obs.results = [];
    ResultadoStore.obs.summary = [];
    ResultadoStore.loadEmpresas();

    this.obs.fetchOptions = debounce(this.handleQueryResults.bind(this), 1000);

  }

  async componentDidMount() {

    this.handleDateSolicitacaoChange(AppStore.obs1.selectedPeriod)

    NotasStore.loadAtrasadasManual();

    ResultadoStore.obs.current_page = 1

    await ResultadoStore.handleConsultaProdutos()

  }

  /**
 * Abre o modal de rastreamento de itens.
 *
 * Ao ser chamada, esta função:
 * 1. Limpa o filtro (`ResultadoStore.obs.filter`) para garantir que
 *    não haja valor residual da busca anterior.
 * 2. Limpa a lista de itens (`ResultadoStore.obs.itens`) para que a
 *    tabela apareça vazia inicialmente.
 * 3. Define `this.obs.open_rastreamentos` como `true`, o que faz com que
 *    o modal de rastreamento seja exibido na tela.
 *
 * @async
 * @function handleOpenRastreamentoItens
 * @returns {Promise<void>}
 */

  async handleOpenRastreamentoItens() {
    ResultadoStore.obs.filter = "";
    ResultadoStore.obs.itens = [];
    this.obs.open_rastreamentos = true
  }

  /**
  * Manipulador para alteração de data/período selecionado.
  *
  * Essa função é chamada quando o usuário escolhe uma nova data ou intervalo
  * de datas em um componente de seleção (ex.: DatePicker, DateRangePicker).
  *
  * Atualiza a propriedade observável `selectedPeriod` dentro de `this.obs`
  * com o valor fornecido.
  *
  * @param val Valor retornado pelo componente de seleção de datas.
  *
  * @returns void
  */

  handleDateChange = (val: any) => {
    this.obs.selectedPeriod = val;
  };

  /**
  * Verifica se a **data de contestação** é diferente da **data de emissão**,
  * desconsiderando horário (comparação no nível do dia).
  *
  * A comparação é feita após normalizar ambas as datas para o início do dia
  * (`startOf('day')`) com base no fuso local configurado no ambiente do `moment`.
  *
  * @param row Objeto contendo as datas do item.
  * @param row.data_emissao Data de emissão (Date, string parseável ou número timestamp).
  * @param row.data_contestacao Data de contestação (Date, string parseável ou número timestamp).
  *
  * @returns `true` se as datas são diferentes (em nível de dia) e `false` caso sejam iguais
  *          ou se alguma das datas não estiver presente.
  */

  isContestacaoDiferente = (row: any) => {
    if (!row?.data_emissao || !row?.data_contestacao) return false;
    const em = moment(row.data_emissao).startOf("day");
    const co = moment(row.data_contestacao).startOf("day");
    return !em.isSame(co, "day");
  };

  /**
  * Retorna a classe CSS que deve ser aplicada a uma linha da tabela
  * com base na diferença entre a data de emissão e a data de contestação.
  *
  * Utiliza a função {@link isContestacaoDiferente} para determinar
  * se a linha representa um item com datas divergentes.
  *
  * @param row Objeto contendo as informações da linha, incluindo as datas.
  * @param _rowIndex Índice numérico da linha na tabela (não utilizado).
  *
  * @returns
  * - `"row-date-mismatch"` caso as datas sejam diferentes.
  * - `""` (string vazia) caso sejam iguais ou alguma delas esteja ausente.
  */
  
  rowClassName = (row: any, _rowIndex: number) => {
    return this.isContestacaoDiferente(row) ? "row-date-mismatch" : "";
  };

  /**
 * Abre o diálogo/modal de informações para um item específico.
 *
 * Armazena o objeto da linha (`row`) em `this.obs.info_row` e
 * define `this.obs.open_info` como `true`, sinalizando para o
 * componente de interface que o modal deve ser exibido.
 *
 * @param row Objeto que representa a linha selecionada na tabela.
 *            Contém os dados que serão exibidos no modal (ex.: número do item,
 *            datas de emissão e contestação, etc.).
 *
 * @returns void
 */
  
  openInfo = (row: any) => {
    this.obs.info_row = row;
    this.obs.open_info = true;
  };

 /**
 * Formata a célula de uma tabela para exibir um ícone de informação
 * quando a data de emissão e a data de contestação forem diferentes.
 *
 * Utiliza a função {@link isContestacaoDiferente} para verificar se há
 * divergência nas datas. Caso positivo, renderiza um botão com ícone "info-sign".
 * Ao clicar no botão, chama {@link openInfo} para abrir o modal com os detalhes.
 *
 * @param _cell Valor bruto da célula (não utilizado neste formato).
 * @param row Objeto que representa a linha atual da tabela, contendo as datas.
 *
 * @returns
 * - Um componente `<Button>` com ícone de informação, quando as datas são diferentes.
 * - `null` quando as datas são iguais ou ausentes (nada é renderizado).
 */

  infoIconFormatter = (_cell: any, row: any) => {
    if (!this.isContestacaoDiferente(row)) return null;

    return (
      <Button
        minimal
        icon="info-sign"
        onClick={() => this.openInfo(row)}
        title="Datas diferentes: clique para detalhes"
      />
    );
  };
  /**
  * Manipula a mudança do período de solicitação no seletor de intervalo de datas.
  *
  * Comportamento:
  * - Valida a data inicial; se ausente ou inválida, limpa o estado e retorna.
  * - Valida a data final, tratando valores inválidos como "não informados".
  * - Se a data inicial for dia 1 e não houver data final, define automaticamente como o último dia do mês.
  * - Atualiza o intervalo de datas (`obs.selectedPeriod`), o `state.date1/date2` e os campos de período no `ResultadoStore`.
  * - Ao final, chama `fetchOptions()` para atualizar a listagem com base no novo período.
  *
  * @param val Array retornado pelo componente de seleção de datas:
  *            - `val[0]`: data inicial obrigatória.
  *            - `val[1]`: data final opcional.
  */

  handleDateSolicitacaoChange = (val: any) => {

    if (!val || !val[0]) {
      this.obs.selectedPeriod = [];
      this.setState({ date1: "", date2: "" });
      ResultadoStore.obs.date_start = null;
      ResultadoStore.obs.date_end = null;
      ResultadoStore.obs.date_referencia = null;
      return;
    }
  
    const start = moment(val[0]).startOf("day");
    if (!start.isValid()) {
      this.obs.selectedPeriod = [];
      this.setState({ date1: "", date2: "" });
      ResultadoStore.obs.date_start = null;
      ResultadoStore.obs.date_end = null;
      ResultadoStore.obs.date_referencia = null;
      return;
    }
  
    let end = val[1] ? moment(val[1]).startOf("day") : null;
    if (end && !end.isValid()) end = null;
  
    if (start.date() === 1) {
      end = end || start.clone().endOf("month");
    }
  
    const period = end ? [start.toDate(), end.toDate()] : [start.toDate(), null];
    this.obs.selectedPeriod = period as any;
  
    const dateStartStr = start.format("YYYY-MM-DD");
    const dateEndStr   = end ? end.format("YYYY-MM-DD") : "";
  
    this.setState({ date1: dateStartStr, date2: dateEndStr });
    ResultadoStore.obs.date_start = dateStartStr;
    ResultadoStore.obs.date_end   = end ? end.format("YYYY-MM-DD") : null;
    ResultadoStore.obs.date_referencia = start.format("MM/YYYY");
  
    this.obs.fetchOptions();

  };

  /*
  * Função responsável por validar o campo descrição e item,
  * caso o campo for vazio ele aplicará a String N/A
  * */

  descricaoFormatter = (cell: any, row: any) => {
    if(!cell) return "N/A"
    return String(cell).trim()
  };

  handleCloseContestar = async () => {

    AppStore.setContestarItem(null);

    this.handleQueryResults()

  };

  async handleQueryResults() {

    if (!AppStore.obs1.selectedEmpresa.cnpj) {
      return
    }

    if (!ResultadoStore.obs.date_start || !ResultadoStore.obs.date_end) {
      return
    }

    if (ResultadoStore.obs.date_start == "Data inválida" || ResultadoStore.obs.date_end == "Data inválida") {
      return
    }

    await ResultadoStore.query();

  }

  handleCloseContestarProduto = () => {

    AppStore.setContestarProduto(null);

  };

  handleCancelContestar = (): void => {

    AppStore.setContestarItem(null);

    this.handleQueryResults()

  };

  handleCancelContestarProduto = (): void => {

    AppStore.setContestarProduto(null);

  };

  handleContestarLote = (): void => {

    ResultadoStore.obs.openContestacaoLote = true;

  };

  handleContestarSugerido = (): void => {

    ResultadoStore.obs.openContestacaoSuregidos = true;

  };

  handleRemoverSelecionadosAll() {

    ResultadoStore.obs.contestar_todos = false;

  }

  handleView = (icmsClassId: any) => {

    this.handleRemoverSelecionadosAll();

    let icmsClass: any = {};

    if (icmsClassId) {

      icmsClass = LookupStore.getIcmsClassificacao(icmsClassId);

    } else {

      icmsClass = { codigo_receita: "0000", nome: "Sem classificação (itens não calculados)" };

    }

    ResultadoStore.setIcmsClassFilter(icmsClass);
    // AppStore.setIcmsDetailPage(1);
    ResultadoStore.obs.current_page = 1

    if (ResultadoStore.obs.modelo == "CT-E") {

      ResultadoStore.obs.selectedTab = "details-cte";

    } else if (ResultadoStore.obs.modelo == "NFS-E") {

      ResultadoStore.obs.selectedTab = "details-nfse";

    } else {

      ResultadoStore.obs.selectedTab = "details";

    }

    this.handleQueryResults()

  };

  handleQuery = async () => {
    // if (!ResultadoStore.obs.libera_busca) {
    //   return;
    // }

    // ResultadoStore.setBooleanFiltros(false);
    // ResultadoStore.obs.results = [];

    if (AppStore.obs1.selectedEmpresa.razao_social != "") {

      // AppStore.setIcmsDetailPage(1);
      ResultadoStore.obs.current_page = 1

      ResultadoStore.setIcmsClassFilter({ codigo_receita: "00000", nome: "Todas" });
      //   AppStore.setSelectedPeriodAndEmpresa(this.obs.selectedPeriod, AppStore.obs1.selectedEmpresa);

      ResultadoStore.obs.selectedTab = "summary";
      ResultadoStore.obs.filters = newIResultadosFilters()

      this.handleQueryResults()

      //   if (ResultadoStore.obs.itemsCount == 0 && ResultadoStore.obs.summaryCount == 0) {
      //     toast.warning('Não foram encontrados resultados.', {});
      //   }

      // await ResultadoStore.handleConsultaProdutos()

    } else {

      toast.warning("Você precisa selecionar uma empresa para filtrar.", {});

    }

  };

  handleCloseContestarLote = async () => {

    ResultadoStore.obs.working = false

    ResultadoStore.resetContestarItems();

    ResultadoStore.obs.openContestacaoLote = false;
    ResultadoStore.obs.openContestacaoSuregidos = false;

    // if (!ResultadoStore.obs.filterErrors && !ResultadoStore.obs.notasRetroativas && !ResultadoStore.obs.notasDivergentes && !ResultadoStore.obs.notasManual) {

    this.handleQueryResults()

    // }

  };

  handleCloseContestarLoteCaculados() {

    ResultadoStore.obs.working = false
    ResultadoStore.resetContestarItems();
    ResultadoStore.obs.openContestacaoLoteCalculados = false;

  }

  valid_export() {

    if (!AppStore.obs1.selectedEmpresa.cnpj) {
      toast.warn("Selecione uma empresa!", {});
      return true
    }

    if (!ResultadoStore.obs.date_start || !ResultadoStore.obs.date_end) {
      toast.warn("Período inválido!", {});
      return true
    }

    if (ResultadoStore.obs.date_start == "Data inválida" || ResultadoStore.obs.date_end == "Data inválida") {
      toast.warn("Período inválido!", {});
      return true
    }

    return false

  }

  handleExport = async () => {

    if(this.valid_export()) return

    let params = {
      date_start: ResultadoStore.obs.date_start,
      date_end: ResultadoStore.obs.date_end,
      cnpj: AppStore.obs1.selectedEmpresa.cnpj,
      razao_social: AppStore.obs1.selectedEmpresa.razao_social,
      tipo: ResultadoStore.obs.tipo,
      modelo: ResultadoStore.obs.modelo,
      estado: AppStore.obs1.selectedEmpresa.uf,
      tipo_exportacao: "export",
    };

    await ResultadoStore.export(params);

    this.props.changeTab("relatorios");

  };

  async handleExportAvisos() {

    if(this.valid_export()) return

    let params = {
      date_start: ResultadoStore.obs.date_start,
      date_end: ResultadoStore.obs.date_end,
      cnpj: AppStore.obs1.selectedEmpresa.cnpj,
      razao_social: AppStore.obs1.selectedEmpresa.razao_social,
      tipo: ResultadoStore.obs.tipo,
      modelo: ResultadoStore.obs.modelo,
      tipo_exportacao: "avisos",
    };

    await ResultadoStore.export(params);

    this.props.changeTab("relatorios");

  }

  async handleSendAvisos() {

    if(this.valid_export()) return

    if (!isValidEmail(AppStore.obs1.selectedEmpresa.email_calculos)) {
      toast.warn("E-mail inválido. Por favor, configure um e-mail em: Empresas -> Editar -> Resultados de Cálculos", {});
      return
    }

    let params = {
      date_start: ResultadoStore.obs.date_start,
      date_end: ResultadoStore.obs.date_end,
      cnpj: AppStore.obs1.selectedEmpresa.cnpj,
      razao_social: AppStore.obs1.selectedEmpresa.razao_social,
      tipo: ResultadoStore.obs.tipo,
      modelo: ResultadoStore.obs.modelo,
      tipo_exportacao: "email",
    };

    await ResultadoStore.export(params);

    this.props.changeTab("relatorios");

  }

  cnpjFormatter = (cell: any) => {
    if (!cell) return "N/A";

    return formatCnpj(String(cell).replace(/\D/g, ""));
  };

  handleSelectTab(tabId: string) {

    ResultadoStore.obs.contestarItems = [];
    ResultadoStore.obs.contestar_todos = false;
    ResultadoStore.setIcmsClassFilter({ codigo_receita: "00000", nome: "Todas" });

    ResultadoStore.obs.selectedTab = tabId;

    this.handleQueryResults()

  }

  handleSelectEmpresa(empresa: any) {

    LookupStore.loadIcmsClassificacoes(empresa.uf)
    ResultadoStore.obs.selectedTab = "summary"
    AppStore.obs1.selectedEmpresa = empresa

    this.handleQueryResults()

  }

  handleChangeTipo(tipo) {
    ResultadoStore.obs.selectedTab = "summary"
    ResultadoStore.obs.tipo = tipo

    this.handleQueryResults()

  }

  /**
 * Formata uma data adicionando 3 horas e retornando no formato "DD/MM/YYYY".
 *
 * Utiliza a biblioteca `moment.js` para manipulação e formatação de datas.
 * A adição de 3 horas pode ser necessária para ajustar fuso horário ou 
 * compensar diferenças de armazenamento no backend.
 *
 * @function dateFormatter
 * @param {string|Date|number} cell - Data original a ser formatada. Pode ser
 *   uma string, objeto `Date` ou timestamp aceito pelo `moment`.
 * @returns {string} Data formatada no padrão "DD/MM/YYYY".
 */

  dateFormatter = (cell) => {
    return moment(cell).add(3, "hour").format("DD/MM/YYYY");
  };

  handleChangeModelo(modelo) {
    ResultadoStore.obs.selectedTab = "summary"
    ResultadoStore.obs.modelo = modelo

    if (modelo == "NFC-E") {

      let minDate = moment(this.obs.selectedPeriod[0]).unix()
      let maxDate = moment(this.obs.selectedPeriod[1]).unix()

      let mes = maxDate - minDate

      if (mes <= 2592000) {

        this.handleDateSolicitacaoChange([this.obs.selectedPeriod[0], this.obs.selectedPeriod[1]])

      } else {

        this.handleDateSolicitacaoChange([this.obs.selectedPeriod[0], null])

      }

    }

    ResultadoStore.obs.filters = newIResultadosFilters()

    this.handleQueryResults()

  }

  get_columns(modelo: string) {

    if (modelo === "NF-E") {
      return [
        {"id": uuidv4(), "header": "Chave NF-e", "xml": "nfe_chv", "campo": "info", "order": 1},
        {"id": uuidv4(), "header": "Data Emissão", "xml": "nfe_dt_doc", "campo": "info", "order": 5},
        {"id": uuidv4(), "header": "NFE - Total", "xml": "nfe_vl_nfe", "campo": "info", "order": 6}
      ]

    } else if (modelo === "NFC-E") {
      return [
        {"id": uuidv4(), "header": "Chave NFC-e", "xml": "nfe_chv", "campo": "info", "order": 1},
        {"id": uuidv4(), "header": "Data Emissão", "xml": "nfe_dt_doc", "campo": "info", "order": 5},
        {"id": uuidv4(), "header": "NFCE - Total", "xml": "nfe_vl_nfe", "campo": "info", "order": 28}
      ]

    } else if (modelo === "CT-E") {
      return [
        {"id": uuidv4(), "header": "Chave CT-e", "xml": "cte_chv", "campo": "info", "order": 1},
        {"id": uuidv4(), "header": "Data Emissão", "xml": "cte_data_emi", "campo": "info", "order": 7},
        {"id": uuidv4(), "header": "CTE - Total", "xml": "cte_vl_doc", "campo": "info", "order": 24}
      ]

    } else if (modelo === "NFS-E") {
      return [
        {"id": uuidv4(), "header": "Chave - NFS-e", "xml": "nfse_chave", "campo": "info", "order": 1},
        {"id": uuidv4(), "header": "Data Processamento - NFS-e", "xml": "nfse_data_proc", "campo": "info", "order": 13},
        {"id": uuidv4(), "header": "Serviço - Valores", "xml": "nfse_valor_serv", "campo": "info", "order": 47}
      ]

    } else {
      return []

    }

  }

  handleExportNotas = async () => {

    if (this.valid_export()) return

    let params = {
      "modelo": ResultadoStore.obs.modelo,
      "tipo": ResultadoStore.obs.tipo,
      "cnpj": AppStore.obs1.selectedEmpresa.cnpj,
      "razao_social": AppStore.obs1.selectedEmpresa.razao_social,
      "filtro": [],
      "columns": this.get_columns(ResultadoStore.obs.modelo),
      "date_start": ResultadoStore.obs.date_start,
      "date_end": ResultadoStore.obs.date_end,
      "format": "xlsx"
    }

    let resp = await RelatorioStore.handleSolicitarRelatorio(params)

    if (resp) window.open("/relatorios", "_blank")

  }

  handleExportFiltros = async () => {

    if(this.valid_export()) return

    let params = {
      date_start: ResultadoStore.obs.date_start,
      date_end: ResultadoStore.obs.date_end,
      cnpj: AppStore.obs1.selectedEmpresa.cnpj,
      razao_social: AppStore.obs1.selectedEmpresa.razao_social,
      tipo: ResultadoStore.obs.tipo,
      modelo: ResultadoStore.obs.modelo,
      estado: AppStore.obs1.selectedEmpresa.uf,
      tipo_exportacao: "export_filtros",
      filters: ResultadoStore.obs.filters,
      icms_classificacao_id: ResultadoStore.getIcmsClassId(ResultadoStore.obs.icmsClassFilter)
    };

    await ResultadoStore.export(params);

    this.props.changeTab("relatorios");

  };

  render() {

    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    let empresaText = AppStore.obs1.selectedEmpresa.razao_social != ""
      ? `${AppStore.obs1.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(AppStore.obs1.selectedEmpresa.cnpj)})`
      : "Selecione uma empresa";

    return (
      <>

        {NotasStore.obs.empresasAtrasadasManual.length > 0 && <NotasManual />}

        <MDBRow data-tut="filtro">
          <MDBCol md="6">
            <FormGroup label="Empresa" className="empresaSelect">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => this.handleSelectEmpresa(e)}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup label="Tipo">
              <HTMLSelect
                onChange={(e) => this.handleChangeTipo(e.target.value)}
                value={ResultadoStore.obs.tipo}
              >
                <option value="Entrada">Entrada</option>
                <option value="Saída">Saída</option>
              </HTMLSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup label="Modelo">
              <HTMLSelect
                onChange={(e) => this.handleChangeModelo(e.target.value)}
                value={ResultadoStore.obs.modelo}
              >
                <option value="NF-E">NF-E</option>
                <option value="NFC-E">NFC-E</option>
                <option value="CT-E">CT-E</option>
                <option value="NFS-E">NFS-E</option>
              </HTMLSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="4" className="inputsPeriodoCalculos">
            <FormGroup label="Período">
              {ResultadoStore.obs.modelo == "NFC-E" ?
                <DateRangePicker30
                  onChange={this.handleDateSolicitacaoChange}
                  value={this.obs.selectedPeriod}
                  disabled={false}
                />
                :
                <DateRangePicker
                  onChange={this.handleDateSolicitacaoChange}
                  value={this.obs.selectedPeriod}
                />
              }
            </FormGroup>
          </MDBCol>

          <MDBCol md="2" className="buttonConsultaCalculo">
            <Button
              text="Buscar"
              intent="primary"
              icon="tick"
              onClick={() => this.handleQuery()}
              loading={ResultadoStore.obs.loading}
              disabled={niveis_acesso.indexOf("c1") == -1}
            />
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol md="12" className="buttonExcel">
            <MDBDropdown>
              <MDBDropdownToggle caret className="btnDefault btnExportResultados" disabled={niveis_acesso.indexOf("c3") == -1}>
                Com os Resultados
              </MDBDropdownToggle>
              <MDBDropdownMenu basic>

                <MDBDropdownItem onClick={() => this.handleExport()} className="actionMani d-flex align-items-center">
                  <AppIcon name="file_export" size={24} color="#3e6971" />
                  &nbsp;<span className="ms-2">Exportar Excel</span>
                </MDBDropdownItem>

                <MDBDropdownItem onClick={() => this.handleExportFiltros()} className="actionMani d-flex align-items-center">
                  <AppIcon name="filter_alt" size={24} color="#3e6971" />
                  &nbsp;<span className="ms-2">Exportar Excel (Filtros)</span>
                </MDBDropdownItem>

                <MDBDropdownItem onClick={() => this.handleExportAvisos()} className="actionMani d-flex align-items-center">
                  <AppIcon name="brightness_alert" size={24} color="#3e6971"/>
                  &nbsp;<span className="ms-2">Exportar Avisos</span>
                </MDBDropdownItem>

                <MDBDropdownItem onClick={() => this.handleSendAvisos()} className="actionMani d-flex align-items-center">
                  <AppIcon name="mail" size={24} color="#3e6971"/>
                  &nbsp;<span className="ms-2">Enviar por E-mail (Cliente)</span>
                </MDBDropdownItem>

                <MDBDropdownItem onClick={() => this.handleExportNotas()} className="actionMani d-flex align-items-center">
                  <AppIcon name="export_notes" size={24} color="#3e6971"/>
                  &nbsp;<span className="ms-2">Exportar Excel (Soma total por Nota)</span>
                </MDBDropdownItem>

              </MDBDropdownMenu>
            </MDBDropdown>
            <MDBBtn
                className="btnDefault btnExportResultados"
                style={{ marginRight: 10, float: "left" }}
                onClick={() => this.handleOpenRastreamentoItens()}
                >
                Rastreamento por chave
            </MDBBtn>
          </MDBCol>
        </MDBRow>

          <Dialog
            isOpen={this.obs.open_rastreamentos}
            onClose={() => (this.obs.open_rastreamentos = false)}
            className="AlertUser modal-busca-itens"
          >
            <h2 className="titleSEFAZ">Buscar itens NF</h2>

            <p>A consulta da chave irá se basear nos filtros selecionados anteriormente de <b>TIpo</b> e <b>Modelo</b></p>

            <MDBRow className="mb-3">
              <MDBCol>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <InputGroup
                      style={{ borderRadius: "10px" }}
                      placeholder="Chave da nota"
                      value={ResultadoStore.obs.filter}
                      onChange={(e) => ResultadoStore.obs.filter = e.target.value}
                    />
                  </div>
                  <Button
                    text={"Buscar"}
                    intent="primary"
                    onClick={ResultadoStore.buscarItens}
                    className="ms-2"
                    style={{ marginLeft: "10px" }}
                    loading={ResultadoStore.obs.loading_rastreamento}
                  />
                </div>
              </MDBCol>
            </MDBRow>

            <div style={{minHeight: "200px", border:"1px solid rgba(27, 99, 111, 0.15)", borderRadius: 10, padding: 5, maxHeight: 400, overflow:"auto"}}>
              <BootstrapTable data={ResultadoStore.obs.itens} trClassName={this.rowClassName}>
                <TableHeaderColumn dataField="id" isKey hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="numero_item" dataFormat={this.descricaoFormatter} width="5%">Item</TableHeaderColumn>
                <TableHeaderColumn dataField="cnpj" dataFormat={this.cnpjFormatter} width="10%">CNPJ</TableHeaderColumn>
                <TableHeaderColumn dataField="razao_social" width="15%">Razão Social</TableHeaderColumn>
                <TableHeaderColumn dataField="descricao" dataFormat={this.descricaoFormatter} width="45%">Descrição</TableHeaderColumn>
                <TableHeaderColumn dataFormat = {this.dateFormatter} dataField="data_emissao" width="10%">Emissão</TableHeaderColumn>
                <TableHeaderColumn dataFormat = {this.dateFormatter} dataField="data_contestacao" width="10%">Contestação</TableHeaderColumn>
                <TableHeaderColumn dataField="info" dataFormat={this.infoIconFormatter} dataAlign="right" width="5%"></TableHeaderColumn>
              </BootstrapTable>
            </div>

            <MDBRow className="mt-3">
              <MDBCol md="12" className="d-flex justify-content-end">
                <Button
                  text="Fechar"
                  intent="primary"
                  onClick={() => (this.obs.open_rastreamentos = false)}
                />
              </MDBCol>
            </MDBRow>

          </Dialog>

          <Dialog
            isOpen={this.obs.open_info}
            onClose={() => (this.obs.open_info = false)}
            title="Atenção"
            className="AlertUser"
          >
            <div className="bp4-dialog-body">
              {this.obs.info_row ? (
                <>
                  A <b>data de contestação</b> do item
                  {this.obs.info_row?.numero_item ? <> <b>#{this.obs.info_row.numero_item}</b></> : null}
                  {" "}está diferente da <b>data de emissão</b>.
                  <br />
                  <br />
                  <b>Emissão:</b> {this.dateFormatter(this.obs.info_row.data_emissao)}<br />
                  <b>Contestação:</b> {this.dateFormatter(this.obs.info_row.data_contestacao)}
                </>
              ) : null}
            </div>

            <div className="bp4-dialog-footer">
              <div className="bp4-dialog-footer-actions">
                <Button onClick={() => (this.obs.open_info = false)} intent="primary" text="Fechar" />
              </div>
            </div>
          </Dialog>

          {ResultadoStore.obs.open_ajuda_salvar && <InfoModal open={ResultadoStore.obs.open_ajuda_salvar} onClose={() => ResultadoStore.obs.open_ajuda_salvar = false} texto_info={`

            O sistema está salvando a contestação, ou seja, será criada uma Memória de Cálculo.  
            Para os próximos produtos com o mesmo <b>CEST, NCM, CST, CFOP, PIS, COFINS e CNPJ(s)</b>, o sistema utilizará automaticamente essa mesma memória.

            <br/><br/>

            <b>Atenção:</b> O MVA não é salvo na memória. O sistema sempre considera o MVA atualizado.

          `} />}

        <Tabs
          id="tabs"
          className={"tabsCalculos"}
          selectedTabId={ResultadoStore.obs.selectedTab}
          onChange={(tabId) => this.handleSelectTab(String(tabId))}
          data-tut="resumo"
        >

          <Tab
            id="summary"
            title="Resumo"
            panel={<ResultadosSummary onView={this.handleView} />}
          />

          {ResultadoStore.obs.modelo == "CT-E" && (
            <Tab
              id="details-cte"
              title="Detalhamento"
              panel={
                <DetalhamentoCte
                  handleContestarLote={this.handleContestarLote.bind(this)}
                />
              }
            />
          )}

          {ResultadoStore.obs.modelo == "NFS-E" && (
            <Tab
              id="details-nfse"
              title="Detalhamento"
              panel={
                <DetalhamentoNfse
                  handleContestarLote={this.handleContestarLote.bind(this)}
                />
              }
            />
          )}

          {ResultadoStore.obs.modelo != "CT-E" && ResultadoStore.obs.modelo != "NFS-E" && (
            <Tab
              id="details"
              data-tut="detalhamento"
              title="Detalhamento"
              panel={
                <DetalhamentoNfe
                  handleContestarLote={this.handleContestarLote.bind(this)}
                  handleContestarSugerido={this.handleContestarSugerido.bind(this)}
                />
              }
            />
          )}

        </Tabs>

        {/* <div className="clearfix"></div> */}

        {AppStore.obs1.contestarItem && (
          <ContestarDialog
            tipo={ResultadoStore.obs.tipo}
            modelo={ResultadoStore.obs.modelo}
            item={AppStore.obs1.contestarItem}
            empresaSelecionada={AppStore.obs1.selectedEmpresa}
            onClose={this.handleCloseContestar}
            onCancel={this.handleCancelContestar}
          />
        )}

        {ResultadoStore.obs.openContestacaoLote && (
          <ContestarLoteDialog
            tipo={ResultadoStore.obs.tipo}
            modelo={ResultadoStore.obs.modelo}
            empresaSelecionada={AppStore.obs1.selectedEmpresa}
            items={ResultadoStore.obs.contestarItems}
            onClose={this.handleCloseContestarLote}
          />
        )}

        {ResultadoStore.obs.openContestacaoLoteCalculados && (
          <ContestarLoteProdutosDialog
            tipo={ResultadoStore.obs.tipo}
            modelo={ResultadoStore.obs.modelo}
            estado={ResultadoStore.obs.estado}
            items={ResultadoStore.obs.contestarItems}
            onClose={this.handleCloseContestarLoteCaculados}
          />
        )}

        {AppStore.obs1.contestarItemProduto && (
          <ContestarProduto
            modelo={ResultadoStore.obs.modelo}
            item={AppStore.obs1.contestarItemProduto}
            empresaSelecionada={AppStore.obs1.selectedEmpresa}
            onClose={this.handleCloseContestarProduto}
            onCancel={this.handleCancelContestarProduto}
            estado={ResultadoStore.obs.estado}
          />
        )}

        {ResultadoStore.obs.openContestacaoSuregidos && (
          <ContestarSugeridoDialog
            tipo={ResultadoStore.obs.tipo}
            modelo={ResultadoStore.obs.modelo}
            empresaSelecionada={AppStore.obs1.selectedEmpresa}
            items={ResultadoStore.obs.contestarItems}
            onClose={this.handleCloseContestarLote}
          />
        )}

        <LoadingModal open={ResultadoStore.obs.loading_solicitacao} onClose={() => ResultadoStore.obs.loading_solicitacao = false} title={"Preparando envio"} />

      </>
    );
  }

}